import { useUser } from '@/contexts/UserContext'

/**
 * useReadOnly hook
 *
 * Returns true when the application is in read-only mode.
 * Currently this happens when an Admin user is impersonating another user.
 *
 * Use this hook to disable action buttons (create, edit, delete) and
 * form submissions across the application.
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const isReadOnly = useReadOnly()
 *
 *   return (
 *     <Button disabled={isReadOnly}>
 *       Create New Record
 *     </Button>
 *   )
 * }
 * ```
 */
export function useReadOnly(): boolean {
  const { isImpersonating } = useUser()
  return isImpersonating
}
